/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import moment from "moment-timezone";
import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import { DATETIME_FORMAT, MILISECONDS } from "../utils/constants";
import { RECEIVE_SPONSOR_DEADLINES } from "../actions/sponsor-actions";
import { getUploadStatus } from "../utils/methods";

const DEFAULT_STATE = {
  deadlines: [],
  total: 0
};

const mapDeadlineData = (data) => ({
  ...data,
  deadline: moment(data.upload_deadline * MILISECONDS).format(DATETIME_FORMAT),
  status: getUploadStatus(data)
});

const sponsorDeadlineListReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case RECEIVE_SPONSOR_DEADLINES: {
      const { data } = payload.response;

      const deadlines = data.map(mapDeadlineData);

      return { ...state, deadlines };
    }
    default:
      return state;
  }
};

export default sponsorDeadlineListReducer;
